import React from 'react';

export default function ScreenshotsSection() {
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">App Screenshots</h2>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/1.png" 
              alt="Poppy Poker App Screenshot 1" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/2.png" 
              alt="Poppy Poker App Screenshot 2" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/3.png" 
              alt="Poppy Poker App Screenshot 3" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/4.png" 
              alt="Poppy Poker App Screenshot 4" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/5.png" 
              alt="Poppy Poker App Screenshot 5" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/6.png" 
              alt="Poppy Poker App Screenshot 6" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/7.png" 
              alt="Poppy Poker App Screenshot 7" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-4 text-center hover:border-purple-500/60 transition-all duration-300">
            <img 
              src="/images/storePhotos/8.png" 
              alt="Poppy Poker App Screenshot 8" 
              className="w-full h-auto rounded-lg"
              style={{ aspectRatio: '9/16' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}


